import { IAppUserPayload } from "../../../types/api/app-user";
import MyPagination from "../../components/Pagination";
import { Tag } from "antd";
import Table, { ColumnType } from "antd/es/table";
import { useNavigate } from "react-router-dom";

const UserTableList = ({
  data,
  isFetching,
  qData,
  refetch,
  DEFAULT_NUQS_CONFIG,
}: {
  data: IAppUserPayload[];
  isFetching: boolean;
  qData: any;
  refetch: any;
  allowURLStateUpdate: boolean;
  DEFAULT_NUQS_CONFIG: any;
}) => {
  const navigate = useNavigate();

  const columns: ColumnType<IAppUserPayload>[] = [
    {
      title: "User ID",
      dataIndex: "user_Id",
      key: "userId",
      render: (userId: string) => (
        <span className="text-gray-800">{userId ?? "-"}</span>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (name: string) => (
        <span className="text-gray-800">{name ?? "-"}</span>
      ),
    },

    {
      title: "Email",

      render: (v, row) => (
        <span className="text-gray-800">{row.email ?? "N/A"}</span>
      ),
    },

    {
      title: "Phone",
      render: (v, row) => (
        <span className="text-gray-800">{row.phone ?? "N/A"}</span>
      ),
    },

    {
      title: "CDD Verification",
      dataIndex: "cddStatus",
      key: "cddStatus",
      render: (cddStatus: string) => <span className="text-gray-800">No</span>,
    },

    {
      title: "Action",
      key: "action",
      align: "right",
      render: (_: any, service: any) => (
        <div className="flex items-center justify-end gap-3">
          <span
            onClick={() => navigate(`/users/details/${service._id}`)}
            className=" cursor-pointer  text-primary"
          >
            View
          </span>
        </div>
      ),
    },
  ];

  return (
    <div>
      <Table
        dataSource={data || []}
        columns={columns}
        rowKey={(item: any) => item._id}
        pagination={false}
        size="middle"
        bordered={false}
        loading={isFetching}
        className="custom-rounded-table"
        scroll={{ x: true }}
        footer={() => (
          <MyPagination
            qData={qData}
            onChange={refetch}
            total={qData.total}
            DEFAULT_NUQS_CONFIG={DEFAULT_NUQS_CONFIG}
          />
        )}
      />
    </div>
  );
};

export default UserTableList;
